<template>
  <div>
    <NavigationBar showBackBtn :actions="actions">
      <template v-slot:title>
        <div class="">
          <small class="mb-0 pb-0 grey--text font-weight-medium caption"
            >Sammeleingabe</small
          >
          <div class="mt-n1 pt-0 pb-2 title text-h6 font-weight-medium">
            Personaldaten
          </div>
        </div>
      </template></NavigationBar
    >
    <section>
      <template>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-skeleton-loader
                v-if="dataIsLoading"
                elevation="2"
                type="card-heading, table"
              ></v-skeleton-loader>
              <v-data-table
                v-else
                v-model="helpers.selectedRecords"
                :items="personnelRecordsWithGrouping"
                :headers="headers"
                no-data-text="Keine Einträge vorhanden"
                show-select
                :search="search"
                hide-default-footer
                item-key="user.uid"
                dense
                disable-pagination
                :group-by="groupBy"
                :sort-by="sortBy"
                class="elevation-1 rounded"
              >
                <template v-slot:top>
                  <v-card flat>
                    <v-card-title class="body-2 v-card__subtitle">
                      <v-text-field
                        v-model="search"
                        label="Suchen"
                        dense
                        prepend-inner-icon="mdi-magnify"
                        outlined
                        hide-details="auto"
                        :disabled="personnelRecords.length === 0"
                        clearable
                        class="mr-1"
                        style="max-width: 300px !important"
                      ></v-text-field>

                      <v-spacer class="hidden-sm-and-down"></v-spacer>

                      <v-btn
                        depressed
                        text
                        outlined
                        class="mr-2"
                        :disabled="!helpers.selectedRecords.length"
                        @click="toggleMassEditDialog()"
                        ><v-icon left>mdi-pencil-box-multiple</v-icon>Auswahl
                        bearbeiten
                      </v-btn>

                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn depressed v-bind="attrs" v-on="on">
                            <span>
                              Gruppieren nach
                              <strong>{{ groupingModeText }}</strong>
                            </span>
                            <v-icon right>mdi-menu-down</v-icon>
                          </v-btn>
                        </template>
                        <v-list nav>
                          <v-list-item-group v-model="groupingMode" mandatory>
                            <v-list-item link dense value="none">
                              <v-list-item-icon>
                                <v-icon dense>mdi-close</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title
                                >Keine Gruppierung</v-list-item-title
                              >
                            </v-list-item>
                            <v-list-item link dense value="group">
                              <v-list-item-icon>
                                <v-icon dense>mdi-folder-account</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title
                                >Benutzergruppe</v-list-item-title
                              >
                            </v-list-item>
                            <v-list-item link dense value="division">
                              <v-list-item-icon>
                                <v-icon dense>mdi-home-group</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>Abteilung</v-list-item-title>
                            </v-list-item>
                            <v-list-item link dense value="rank">
                              <v-list-item-icon>
                                <v-icon dense>mdi-shield-star</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>Dienstgrad</v-list-item-title>
                            </v-list-item>
                            <v-list-item link dense value="dutyPosition">
                              <v-list-item-icon>
                                <v-icon dense>mdi-badge-account</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title
                                >Dienststellung</v-list-item-title
                              >
                            </v-list-item>
                            <v-list-item link dense value="status">
                              <v-list-item-icon>
                                <v-icon dense>mdi-list-status</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>Status</v-list-item-title>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-menu>
                    </v-card-title>
                    <v-divider></v-divider>
                  </v-card>
                </template>
                <template
                  v-slot:[`group.header`]="{ items, group, isOpen, toggle }"
                >
                  <th :colspan="headers.length + 1">
                    <v-icon @click="toggle" class="mr-2"
                      >{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}
                    </v-icon>
                    <span>
                      {{ stripPrefix(group) }}
                    </span>
                    <span class="grey--text ml-2">({{ items.length }})</span>
                  </th>
                </template>
                <template v-slot:item.personnelNumber="{ item }">
                  <v-text-field
                    v-model="item.personnelNumber"
                    outlined
                    dense
                    hide-details="auto"
                    class="my-2"
                  ></v-text-field>
                </template>
                <template v-slot:item.birthdate="{ item }">
                  <v-text-field
                    v-model="item.birthdate"
                    type="date"
                    outlined
                    dense
                    hide-details="auto"
                    class="my-2"
                  ></v-text-field>
                </template>
                <template v-slot:item.birthplace="{ item }">
                  <v-text-field
                    v-model="item.birthplace"
                    outlined
                    dense
                    hide-details="auto"
                    class="my-2"
                  ></v-text-field>
                </template>
                <template v-slot:item.division="{ item }">
                  <v-select
                    v-model="item.division"
                    :items="divisions"
                    outlined
                    dense
                    hide-details="auto"
                    item-text="title"
                    return-object
                    class="my-2"
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip label outlined class="font-weight-medium"
                        >{{ item.title }}
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">{{
                          item.title
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          item.shortTitle
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </template>
                <template v-slot:item.rank="{ item }">
                  <v-select
                    v-model="item.rank"
                    :items="ranks"
                    outlined
                    dense
                    hide-details="auto"
                    item-text="title"
                    return-object
                    class="my-2"
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip label outlined>
                        <img
                          v-if="item.badgeUrl"
                          contain
                          height="30px"
                          :src="item.badgeUrl.size125x125"
                          class="mr-2 py-1"
                        />
                        <div class="font-weight-medium">
                          {{ item.title }}
                        </div>
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-avatar v-if="item.badgeUrl" tile>
                        <v-img contain :src="item.badgeUrl.size125x125" />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">{{
                          item.title
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          item.shortTitle
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </template>
                <template v-slot:item.dutyPosition="{ item }">
                  <v-select
                    v-model="item.dutyPosition"
                    :items="dutyPositions"
                    outlined
                    dense
                    hide-details="auto"
                    item-text="title"
                    return-object
                    class="my-2"
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip label outlined>
                        <img
                          v-if="item.badgeUrl"
                          contain
                          height="30px"
                          :src="item.badgeUrl.size125x125"
                          class="mr-2 py-1"
                        />
                        <div class="font-weight-medium">
                          {{ item.title }}
                        </div>
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-avatar v-if="item.badgeUrl" tile>
                        <v-img contain :src="item.badgeUrl.size125x125" />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">{{
                          item.title
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          item.shortTitle
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </template>
                <template v-slot:item.status="{ item }">
                  <v-select
                    v-model="item.status"
                    :items="statusOptions"
                    outlined
                    dense
                    hide-details="auto"
                    class="my-2"
                  ></v-select>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <custom-dialog
      v-if="helpers.massEditDialog.model"
      @close="toggleMassEditDialog()"
      title="Auswahl bearbeiten"
      text="Änderungen werden auf alle ausgewählten Einträge angewendet."
      width="l"
      :btnAction="massEditSelection"
      fullscreenOnMobile
    >
      <template v-slot:content>
        <v-form
          v-model="helpers.massEditDialog.formIsValid"
          ref="editDialogForm"
          @submit.prevent="massEditSelection()"
        >
          <v-card outlined>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    v-model="helpers.massEditDialog.updateValues"
                    multiple
                    label="Personalnummer überschreiben"
                    hide-details="auto"
                    value="personnelNumber"
                    class="pb-2 mt-0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="helpers.massEditDialog.newData.personnelNumber"
                    outlined
                    dense
                    label="Personalnummer"
                    :disabled="
                      !helpers.massEditDialog.updateValues.includes(
                        'personnelNumber'
                      )
                    "
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    v-model="helpers.massEditDialog.updateValues"
                    multiple
                    label="Geburtsdatum überschreiben"
                    hide-details="auto"
                    value="birthdate"
                    class="pb-2 mt-0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="helpers.massEditDialog.newData.birthdate"
                    type="date"
                    outlined
                    dense
                    label="Geburtsdatum"
                    :disabled="
                      !helpers.massEditDialog.updateValues.includes('birthdate')
                    "
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    v-model="helpers.massEditDialog.updateValues"
                    multiple
                    label="Geburtsort überschreiben"
                    hide-details="auto"
                    value="birthplace"
                    class="pb-2 mt-0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="helpers.massEditDialog.newData.birthplace"
                    outlined
                    dense
                    label="Geburtsort"
                    :disabled="
                      !helpers.massEditDialog.updateValues.includes(
                        'birthplace'
                      )
                    "
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    v-model="helpers.massEditDialog.updateValues"
                    multiple
                    label="Abteilung/Einheit überschreiben"
                    hide-details="auto"
                    value="division"
                    class="pb-2 mt-0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="helpers.massEditDialog.newData.division"
                    :items="divisions"
                    label="Abteilung/Einheit"
                    outlined
                    dense
                    hide-details="auto"
                    item-text="title"
                    return-object
                    :disabled="
                      !helpers.massEditDialog.updateValues.includes('division')
                    "
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip label outlined class="font-weight-medium"
                        >{{ item.title }}
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">{{
                          item.title
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          item.shortTitle
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    v-model="helpers.massEditDialog.updateValues"
                    multiple
                    label="Dienstgrad überschreiben"
                    hide-details="auto"
                    value="rank"
                    class="pb-2 mt-0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="helpers.massEditDialog.newData.rank"
                    :items="ranks"
                    label="Dienstgrad"
                    outlined
                    dense
                    hide-details="auto"
                    item-text="title"
                    return-object
                    :disabled="
                      !helpers.massEditDialog.updateValues.includes('rank')
                    "
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip label outlined>
                        <img
                          v-if="item.badgeUrl"
                          contain
                          height="30px"
                          :src="item.badgeUrl.size125x125"
                          class="mr-2 py-1"
                        />
                        <div class="font-weight-medium">
                          {{ item.title }}
                        </div>
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-avatar v-if="item.badgeUrl" tile>
                        <v-img contain :src="item.badgeUrl.size125x125" />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">{{
                          item.title
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          item.shortTitle
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    v-model="helpers.massEditDialog.updateValues"
                    multiple
                    label="Dienststellung überschreiben"
                    hide-details="auto"
                    value="dutyPosition"
                    class="pb-2 mt-0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="helpers.massEditDialog.newData.dutyPosition"
                    :items="dutyPositions"
                    label="Dienststellung"
                    outlined
                    dense
                    hide-details="auto"
                    item-text="title"
                    return-object
                    :disabled="
                      !helpers.massEditDialog.updateValues.includes(
                        'dutyPosition'
                      )
                    "
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip label outlined>
                        <img
                          v-if="item.badgeUrl"
                          contain
                          height="30px"
                          :src="item.badgeUrl.size125x125"
                          class="mr-2 py-1"
                        />
                        <div class="font-weight-medium">
                          {{ item.title }}
                        </div>
                      </v-chip>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-avatar v-if="item.badgeUrl" tile>
                        <v-img contain :src="item.badgeUrl.size125x125" />
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">{{
                          item.title
                        }}</v-list-item-title>
                        <v-list-item-subtitle>{{
                          item.shortTitle
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    v-model="helpers.massEditDialog.updateValues"
                    multiple
                    label="Status überschreiben"
                    hide-details="auto"
                    value="status"
                    class="pb-2 mt-0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="helpers.massEditDialog.newData.status"
                    :items="statusOptions"
                    label="Status"
                    outlined
                    dense
                    hide-details="auto"
                    :disabled="
                      !helpers.massEditDialog.updateValues.includes('status')
                    "
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-form>
      </template>
    </custom-dialog>
    <CustomDialog
      v-if="helpers.changesDialog.model"
      @close="toggleChangesDialog()"
      title="Änderungen prüfen"
      text="Folgende Änderungen wurden erkannt und werden beim Speichern übernommen:"
      width="xxl"
      fullscreenOnMobile
      :errorMessage="helpers.changesDialog.errorMessage"
      :btnAction="saveChanges"
      :loading="helpers.changesDialog.loading"
      btnText="Personaldaten aktualisieren"
      btnColor="success"
      :btnDisabled="!modifiedRecordsCount"
    >
      <template v-slot:content>
        <v-card outlined class="mt-2">
          <v-data-table
            :items="changedRecords"
            :headers="changesTableHeaders"
            sort-by="firstName"
            item-key="user.uid"
            disable-pagination
            hide-default-footer
            mobile-breakpoint="0"
            fixed-header
            height="35vh"
            class="mt-1"
            no-data-text="Es wurden keine Änderungen an Personaldaten vorgenommen."
          >
            <template v-slot:[`item.user`]="{ item }">
              <div class="d-flex flex-column">
                <span
                  class="d-block font-weight-semibold text--primary text-truncate"
                  >{{ item.firstName }} {{ item.lastName }}</span
                >
                <small class="grey--text">{{ item.personnelNumber }}</small>
              </div>
            </template>
            <template v-slot:[`item.personnelNumber`]="{ item }">
              <span
                v-if="item.personnelNumber !== item.original.personnelNumber"
              >
                {{ item.personnelNumber }}
              </span>
            </template>
            <template v-slot:[`item.birthdate`]="{ item }">
              <span v-if="item.birthdate !== item.original.birthdate">
                {{ timestampConverter(item.birthdate) }}
              </span>
            </template>
            <template v-slot:[`item.birthplace`]="{ item }">
              <span v-if="item.birthplace !== item.original.birthplace">
                {{ item.birthplace }}
              </span>
            </template>
            <template v-slot:[`item.division`]="{ item }">
              <v-chip
                v-if="
                  getDivisionTitle(item.division) !==
                  getDivisionTitle(item.original.division)
                "
                label
                small
                outlined
                class="font-weight-medium"
              >
                {{ getDivisionTitle(item.division) }}
              </v-chip>
            </template>
            <template v-slot:[`item.rank`]="{ item }">
              <v-chip
                v-if="
                  getRankTitle(item.rank) !== getRankTitle(item.original.rank)
                "
                label
                small
                outlined
                class="font-weight-medium"
              >
                {{ getRankTitle(item.rank) }}
              </v-chip>
            </template>
            <template v-slot:[`item.dutyPosition`]="{ item }">
              <v-chip
                v-if="
                  getDutyPositionTitle(item.dutyPosition) !==
                  getDutyPositionTitle(item.original.dutyPosition)
                "
                label
                small
                outlined
                class="font-weight-medium"
              >
                {{ getDutyPositionTitle(item.dutyPosition) }}
              </v-chip>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                v-if="item.status !== item.original.status"
                label
                small
                outlined
                class="font-weight-medium"
              >
                {{ getStatusText(item.status) }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
/**
 * PersonnelRecordsBulkEdit.vue
 *
 * Bulk edit component for personnel master data (Stammdaten).
 * Allows users to edit multiple personnel records simultaneously through a data table interface.
 *
 * Features:
 * - Editable fields directly in the table
 * - Mass edit dialog to apply changes to multiple selected records at once
 * - Search and filter functionality
 * - Batch write to Firestore for efficient data updates
 * - Warns user about unsaved changes before leaving
 *
 * Extensibility:
 * To add additional editable fields from other Firestore collections (e.g., contact data):
 * 1. Add the field to the headers array in data()
 * 2. Add the corresponding template slot in the v-data-table
 * 3. Add the field to massEditDialog.newData in data()
 * 4. Add the corresponding form field in the mass edit dialog
 * 5. Update massEditSelection() to handle the new field
 * 6. Update saveChanges() to save the data to the appropriate Firestore collection
 *
 * For example, to add contact data from personnelRecords_contact collection:
 * - Add fields like phone, email, address to headers
 * - Fetch data from personnelRecords_contact in initialize()
 * - Save changes to personnelRecords_contact in saveChanges()
 */
import { db, FieldValue, Timestamp } from "@/firebase";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import CustomDialog from "@/components/_systemwide/CustomDialog.vue";
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import {
  GET_PERSONNEL_RECORDS,
  GET_RANKS,
  GET_DUTY_POSITIONS,
  GET_DIVISIONS,
} from "@/store/action-types.js";
import {
  PERSONNEL_STATUS_OPTIONS,
  getPersonnelStatusText,
  getPersonnelStatusPrefix,
  convertToDateString,
  formatDateForDisplay,
} from "@/util/personnel-records.js";

export default {
  name: "personnel-records-bulk-edit",
  components: {
    NavigationBar,
    CustomDialog,
  },
  data() {
    return {
      actions: [
        {
          title: "Speichern",
          icon: "mdi-content-save",
          actionStyle: "textBtnSubmit",
          function: this.toggleChangesDialog,
        },
      ],
      saveSucceeded: false,
      dataIsLoading: true,
      search: "",
      groupingMode: "none",
      sortBy: "user.displayName",
      headers: [
        {
          text: "Personalnummer",
          value: "personnelNumber",
          divider: true,
        },
        { text: "Vorname", value: "firstName", sortable: true },
        { text: "Nachname", value: "lastName", sortable: true, divider: true },
        { text: "Geburtsdatum", value: "birthdate", divider: true },
        { text: "Geburtsort", value: "birthplace", divider: true },
        { text: "Abteilung/Einheit", value: "division", divider: true },
        { text: "Dienstgrad", value: "rank", divider: true },
        { text: "Dienststellung", value: "dutyPosition", divider: true },
        { text: "Status", value: "status", divider: true },
      ],
      statusOptions: PERSONNEL_STATUS_OPTIONS,

      personnelRecords: [],
      originalPersonnelRecords: [],
      originalRecordsMap: new Map(), // For O(1) lookups

      helpers: {
        selectedRecords: [],
        massEditDialog: {
          model: false,
          formIsValid: false,
          updateValues: [],
          newData: {
            personnelNumber: null,
            birthdate: null,
            birthplace: null,
            division: null,
            rank: null,
            dutyPosition: null,
            status: null,
          },
        },
        saveDialog: {
          model: false,
          loading: false,
          errorMessage: "",
        },
        changesDialog: {
          model: false,
          loading: false,
          errorMessage: "",
        },
      },
      changesTableHeaders: [
        { text: "Name", value: "user", sortable: true },
        { text: "Personalnummer", value: "personnelNumber", sortable: false },
        { text: "Geburtsdatum", value: "birthdate", sortable: false },
        { text: "Geburtsort", value: "birthplace", sortable: false },
        { text: "Abteilung", value: "division", sortable: false },
        { text: "Dienstgrad", value: "rank", sortable: false },
        { text: "Dienststellung", value: "dutyPosition", sortable: false },
        { text: "Status", value: "status", sortable: false },
      ],
    };
  },
  computed: {
    personnelRecordsStore() {
      return this.$store.state.memberManagement.personnelRecords;
    },
    ranks() {
      return this.$store.state.memberManagement.ranks;
    },
    dutyPositions() {
      return this.$store.state.memberManagement.dutyPositions;
    },
    divisions() {
      return this.$store.state.memberManagement.divisions;
    },
    groupingModeText() {
      const modes = {
        none: "Keine Gruppierung",
        group: "Benutzergruppe",
        division: "Abteilung",
        rank: "Dienstgrad",
        dutyPosition: "Dienststellung",
        status: "Status",
      };
      return modes[this.groupingMode] || "Keine Gruppierung";
    },
    groupBy() {
      if (this.groupingMode === "none") {
        return null;
      }
      return `groupBy${
        this.groupingMode.charAt(0).toUpperCase() + this.groupingMode.slice(1)
      }`;
    },
    personnelRecordsWithGrouping() {
      // Add grouping properties only if they don't exist or grouping mode changed
      // This ensures v-model bindings in the table update the actual records
      const currentMode = this.groupingMode;

      this.personnelRecords.forEach((record) => {
        // Only recalculate if not already set or mode changed
        if (
          !record._lastGroupingMode ||
          record._lastGroupingMode !== currentMode
        ) {
          record.groupByGroup =
            this.getGroupPrefix(record.group) +
            "_" +
            (record.group?.title || "Keine Gruppe");
          record.groupByDivision =
            this.getGroupPrefix(record.division) +
            "_" +
            (record.division?.title || "Keine Abteilung");
          record.groupByRank =
            this.getGroupPrefix(record.rank) +
            "_" +
            (record.rank?.title || "Kein Dienstgrad");
          record.groupByDutyPosition =
            this.getGroupPrefix(record.dutyPosition) +
            "_" +
            (record.dutyPosition?.title || "Keine Dienststellung");
          record.groupByStatus =
            this.getStatusPrefix(record.status) +
            "_" +
            this.getStatusText(record.status);
          record._lastGroupingMode = currentMode;
        }
      });
      return this.personnelRecords;
    },
    changedRecords() {
      return this.personnelRecords
        .map((record) => {
          const original =
            this.originalRecordsMap.get(record.user?.uid) || record;
          return {
            ...record,
            original,
          };
        })
        .filter((record) => this.isRecordModified(record, record.original));
    },
    modifiedRecordsCount() {
      return this.personnelRecords.filter((record) => {
        const original = this.originalRecordsMap.get(record.user?.uid);
        return original && this.isRecordModified(record, original);
      }).length;
    },
  },
  created() {
    this.initialize();
  },
  beforeRouteLeave(to, from, next) {
    if (this.saveSucceeded) {
      next();
      return;
    }
    if (this.modifiedRecordsCount > 0) {
      const answer = window.confirm(
        "Willst Du die Seite wirklich verlassen? Nicht gespeicherte Änderungen gehen verloren."
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  methods: {
    async initialize() {
      await this.getPersonnelRecords();
      await this.getRanks();
      await this.getDutyPositions();
      await this.getDivisions();
      this.personnelRecords = JSON.parse(
        JSON.stringify(this.personnelRecordsStore)
      );
      this.originalPersonnelRecords = JSON.parse(
        JSON.stringify(this.personnelRecordsStore)
      );

      // Convert birthdate Timestamps to yyyy-MM-dd format for date inputs
      this.personnelRecords.forEach((record) => {
        record.birthdate = convertToDateString(record.birthdate);
      });

      this.originalPersonnelRecords.forEach((record) => {
        record.birthdate = convertToDateString(record.birthdate);
        // Build lookup map for O(1) access
        if (record.user?.uid) {
          this.originalRecordsMap.set(record.user.uid, record);
        }
      });

      this.dataIsLoading = false;
    },
    getPersonnelRecords() {
      return this.$store.dispatch(
        `${MEMBER_MANAGEMENT}${GET_PERSONNEL_RECORDS}`,
        {
          organizationId: this.$route.params.organizationId,
        }
      );
    },
    getRanks() {
      return this.$store.dispatch(`${MEMBER_MANAGEMENT}${GET_RANKS}`, {
        organizationId: this.$route.params.organizationId,
      });
    },
    getDutyPositions() {
      return this.$store.dispatch(`${MEMBER_MANAGEMENT}${GET_DUTY_POSITIONS}`, {
        organizationId: this.$route.params.organizationId,
      });
    },
    getDivisions() {
      return this.$store.dispatch(`${MEMBER_MANAGEMENT}${GET_DIVISIONS}`, {
        organizationId: this.$route.params.organizationId,
      });
    },
    toggleMassEditDialog() {
      this.helpers.massEditDialog.model = !this.helpers.massEditDialog.model;
    },
    massEditSelection() {
      // Create a temporary map for fast lookups
      const recordsMap = new Map(
        this.personnelRecords.map((r) => [r.user?.uid, r])
      );

      this.helpers.selectedRecords.forEach((selectedItem) => {
        const record = recordsMap.get(selectedItem.user?.uid);

        if (record) {
          if (
            this.helpers.massEditDialog.updateValues.includes("personnelNumber")
          ) {
            record.personnelNumber =
              this.helpers.massEditDialog.newData.personnelNumber;
          }

          if (this.helpers.massEditDialog.updateValues.includes("birthdate")) {
            record.birthdate = this.helpers.massEditDialog.newData.birthdate;
          }

          if (this.helpers.massEditDialog.updateValues.includes("birthplace")) {
            record.birthplace = this.helpers.massEditDialog.newData.birthplace;
          }

          if (this.helpers.massEditDialog.updateValues.includes("division")) {
            record.division = this.helpers.massEditDialog.newData.division;
          }

          if (this.helpers.massEditDialog.updateValues.includes("rank")) {
            record.rank = this.helpers.massEditDialog.newData.rank;
          }

          if (
            this.helpers.massEditDialog.updateValues.includes("dutyPosition")
          ) {
            record.dutyPosition =
              this.helpers.massEditDialog.newData.dutyPosition;
          }

          if (this.helpers.massEditDialog.updateValues.includes("status")) {
            record.status = this.helpers.massEditDialog.newData.status;
          }
        }
      });

      // Close the dialog and reset
      this.helpers.massEditDialog.model = false;
      this.helpers.selectedRecords = [];
      this.helpers.massEditDialog.updateValues = [];
      this.helpers.massEditDialog.newData = {
        personnelNumber: null,
        birthdate: null,
        birthplace: null,
        division: null,
        rank: null,
        dutyPosition: null,
        status: null,
      };
    },
    toggleSaveDialog() {
      this.helpers.saveDialog.model = !this.helpers.saveDialog.model;
    },
    toggleChangesDialog() {
      this.helpers.changesDialog.model = !this.helpers.changesDialog.model;
    },
    stripPrefix(item) {
      if (!item) return "";
      const underscoreIndex = item.indexOf("_");
      return underscoreIndex !== -1
        ? item.substring(underscoreIndex + 1)
        : item;
    },
    getGroupPrefix(item) {
      if (!item || !item.sortKey) return "9999";
      return item.sortKey.toString().padStart(4, "0");
    },
    getStatusPrefix(status) {
      return getPersonnelStatusPrefix(status);
    },
    getStatusText(status) {
      return getPersonnelStatusText(status);
    },
    getDivisionTitle(division) {
      return division?.title || "";
    },
    getRankTitle(rank) {
      return rank?.title || "";
    },
    getDutyPositionTitle(dutyPosition) {
      return dutyPosition?.title || "";
    },
    timestampConverter(value) {
      return formatDateForDisplay(value);
    },
    isRecordModified(record, original) {
      // Compare only the editable fields to determine if a record has been modified
      if (!original) return false;

      // Check simple fields first (fast)
      if (
        record.personnelNumber !== original.personnelNumber ||
        record.birthdate !== original.birthdate ||
        record.birthplace !== original.birthplace ||
        record.status !== original.status
      ) {
        return true;
      }

      // Check object references before stringifying (medium speed)
      if (
        record.division !== original.division ||
        record.rank !== original.rank ||
        record.dutyPosition !== original.dutyPosition
      ) {
        // Only stringify if references differ (slow but necessary)
        return (
          JSON.stringify(record.division) !==
            JSON.stringify(original.division) ||
          JSON.stringify(record.rank) !== JSON.stringify(original.rank) ||
          JSON.stringify(record.dutyPosition) !==
            JSON.stringify(original.dutyPosition)
        );
      }

      return false;
    },
    async saveChanges() {
      this.helpers.changesDialog.loading = true;
      this.helpers.changesDialog.errorMessage = "";

      try {
        const baseRef = db
          .collection("organizations")
          .doc(this.$route.params.organizationId);

        // Find modified records by comparing with originals using Map for O(1) lookup
        const modifiedRecords = this.personnelRecords.filter((record) => {
          const original = this.originalRecordsMap.get(record.user?.uid);
          return original && this.isRecordModified(record, original);
        });

        if (modifiedRecords.length === 0) {
          this.helpers.changesDialog.loading = false;
          return;
        }

        // Firestore batch writes have a limit of 500 operations
        const batchSize = 500;
        const batches = [];

        // Create batches for all modified records
        for (let i = 0; i < modifiedRecords.length; i += batchSize) {
          const batch = db.batch();
          const batchRecords = modifiedRecords.slice(i, i + batchSize);

          batchRecords.forEach((record) => {
            const generalRef = baseRef
              .collection("personnelRecords_general")
              .doc(record.user.uid);

            // Convert birthdate from YYYY-MM-DD string to Firestore Timestamp
            let birthdateTimestamp = null;
            if (record.birthdate) {
              const date = new Date(record.birthdate);
              birthdateTimestamp = Timestamp.fromDate(date);
            }

            const updateData = {
              personnelNumber: record.personnelNumber || null,
              birthdate: birthdateTimestamp,
              birthplace: record.birthplace || null,
              division: record.division || null,
              rank: record.rank || null,
              dutyPosition: record.dutyPosition || null,
              status: record.status || null,
              meta: {
                lastUpdatedAt: FieldValue.serverTimestamp(),
                // lastUpdatedBy: this.$store.state.user.currentUser.uid,
              },
            };

            batch.set(generalRef, updateData, { merge: true });
          });

          batches.push(batch);
        }

        // Commit all batches sequentially
        await Promise.all(batches.map((batch) => batch.commit()));

        this.saveSucceeded = true;
        this.$router.push({
          name: "member-management-personnel-records",
          params: {
            organizationId: this.$route.params.organizationId,
          },
        });
      } catch (error) {
        console.error("Error saving changes:", error);
        this.helpers.changesDialog.errorMessage = error.message;
        this.helpers.changesDialog.loading = false;
      }
    },
  },
};
</script>
